import { CREATE_ROLE, DELETE_ROLE, GET_ROLES } from './roles.types';
import { AnyAction, Reducer } from 'redux';
import { RolesState } from 'models/redux/roles.state';

const initialSettings: RolesState = {
  roles: [],
  loadingRoles: false,
};

const reducer: Reducer<RolesState> = (
  state: RolesState = initialSettings,
  action: AnyAction,
) => {
  switch (action.type) {
    case CREATE_ROLE:
    case DELETE_ROLE:
    case GET_ROLES:
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
};

export default reducer;
